export default "__VITE_PUBLIC_ASSET__06d8207a__"